export const additionalParameters=[
    "Clipnorm",
    "LearningRate"
]